import { CrossStorageHub } from 'cross-storage';
import 'regenerator-runtime/runtime';
import { loadFromConfig } from '../src/utils/configLoader';
import { moduleHotAccept } from '../src/utils/hotModules';

const DOMAIN_WHITELIST = loadFromConfig('DOMAIN_WHITELIST');

try {
  CrossStorageHub.init(
    DOMAIN_WHITELIST.map((domain) => ({
      origin: new RegExp(domain),
      allow: ['get', 'set', 'del', 'getKeys', 'clear'],
    })),
  );
} catch (e) {
  console.error('Iframe CrossStorageHub error');
}

moduleHotAccept(module);
